const AppId = {
  APP_NO1: 'APP_NO1',
  INSURANCE_APP: 'INSURANCE_APP',
  SUPPLEMENT_APP: 'SUPPLEMENT_APP',
  ELITE_APP: 'ELITE_APP',
  DIVAY_APP: 'DIVAY_APP',
  DIVAY_INSURANCE_APP: 'DIVAY_INSURANCE_APP',
  DIVAY_SUPPLEMENT_APP: 'DIVAY_SUPPLEMENT_APP',
}

export default AppId;
